import React from "react";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { Hidden } from "../../offering/hidden";
import { Spacer } from "../../offering/spacer";

import "./footer.css";
import { Icon } from "@/components";

export const TERMS =
  "https://meet-production.s3-us-west-1.amazonaws.com/documents/flexspace-terms.pdf";
export const PRIVACY_POLICY =
  "https://meet-production.s3-us-west-1.amazonaws.com/documents/flexspace-privacy.pdf";

export function FooterV2({ instagramLink }: { instagramLink?: string }) {
  const { fbt } = useI18n();

  return (
    <div className="footer-v2 d-flex align-items-center flex-column gap-4">
      {instagramLink && (
        <a href={instagramLink} target="_blank">
          <Icon size={32} name="instagram" />
        </a>
      )}
      <div className="d-flex justify-content-center">
        <span>{fbt("Powered by")}</span>
        <Spacer size={4} direction="horizontal" />
        <FooterLink href="https://flexspace.ai">Flexspace&reg;</FooterLink>
        <Spacer size={4} direction="horizontal" />
        <span>|</span>
        <Spacer size={4} direction="horizontal" />
        <FooterLink href={PRIVACY_POLICY}>{fbt("Privacy")}</FooterLink>
        <Spacer size={4} direction="horizontal" />
        <span>|</span>
        <Spacer size={4} direction="horizontal" />
        <FooterLink href={TERMS}>{fbt("Terms")}</FooterLink>
        <Hidden md>
          <Spacer size={70} />
        </Hidden>
      </div>
    </div>
  );
}

interface FooterLinkProps {
  href?: string;
  children: React.ReactText;
}

function FooterLink(props: FooterLinkProps) {
  const { href, children } = props;

  return (
    <a
      className="footer-link"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}
